function objectToCaseMap(obj:any) {
    const caseMap = new Map();
    for (let name in obj) {
        const [cases, deaths, recovered, hospitalized] = obj[name];
        caseMap.set(name, {
            cases, deaths, recovered, hospitalized
        });
    }
    return caseMap;
};

export const COVIDCases = new Map<string, any>([
    ['2020-05-01', new Map(objectToCaseMap({
        // cases, deaths, recovered, hospitalized
        "Alabama": [7019, 269, -1, 978],
        "Alaska": [355, 9, 252, 36],
        "American Samoa": [0, 0, -1, -1],
        "Arizona": [7648, 320, -1, 1169],
        "Arkansas": [3281, 61, 1339, 414],
        "California": [48917, 1982, 24000, -1],
        "Colorado": [15284, 777, -1, 2697],
        "Connecticut": [27700, 2257, -1, -1],
        "Delaware": [4734, 152, 1275],
        "District of Columbia": [4323, 224, 660, -1],
        "Florida": [33690, 1268, -1, 5589],
        "Georgia": [26237, 1131, -1, 5186],
        "Guam": [145, 5, 131, -1],
        "Hawaii": [618, 16, 526, 70],
        "Idaho": [1984, 60, 1121, 175],
        "Illinois": [52918, 2355, -1, -1],
        "Indiana": [17835, 1007, -1, -1],
        "Iowa": [7145, 162, 2697, -1],
        "Kansas": [4238, 129, -1, 523],
        "Kentucky": [4708, 240, -1, -1],
        "Louisiana": [28001, 1862, -1],
        "Maine": [1095, 53, 631, 170],
        "Maryland": [21742, 1047, 1432, 4559],
        "Massachusetts": [62205, 3562, -1, 5942],
        "Michigan": [41379, 3789, 8342, -1],
        "Minnesota": [5136, 343, 2172, 1044],
        "Mississippi": [6815, 261, -1, -1],
        "Missouri": [7582, 329, -1, -1],
        "Montana": [453, 16, 392, 61],
        "Nebraska": [4281, 70, -1, -1],
        "Nevada": [4998, 243, -1, -1],
        "New Hampshire": [2054, 66, 980, 259],
        "New Jersey": [118652, 7228, 24000, 5972],
        "New Mexico": [3411, 123, -1, -1],
        "New York": [304372, 18321, 33332, -1],
        "North Carolina": [10509, 378, -1, -1],
        "North Dakota": [1067, 19, 458, 85],
        "Northern Mariana Islands": [14, 2, 12, -1],
        "Ohio": [18027, 975, -1, 3533],
        "Oklahoma": [3618, 222, 2401, -1],
        "Oregon": [2510, 103, -1, 578],
        "Pennsylvania": [45763, 2292, -1, -1],
        "Puerto Rico": [1539, 92, -1, -1],
        "Rhode Island": [8621, 266, -1, -1],
        "South Carolina": [6095, 244, -1, -1],
        "South Dakota": [2449, 17, 1573, 173],
        "Tennessee": [10735, 199, 5338, 1045],
        "Texas": [28087, 782, 13353, -1],
        "Utah": [4672, 46, 1939, 390],
        "Virgin Islands": [66, 4, 51, -1],
        "Vermont": [866, 49, -1, -1],
        "Virginia": [15846, 552, -1, 2322],
        "Washington": [14070, 801, -1, -1],
        "West Virginia": [1125, 44, 555, -1],
        "Wisconsin": [6854, 316, -1, 1512],
        "Wyoming": [559, 7, 373, 56]
    }))]
]);

const regionList = ([
    ["California", 39512223],
    ["Texas", 28995881],
    ["Florida", 21477737],
    ["New York", 19453561],
    ["Pennsylvania", 12801989],
    ["Illinois", 12671821],
    ["Ohio", 11689100],
    ["Georgia", 10617423],
    ["North Carolina", 10488084],
    ["Michigan", 9986857],
    ["New Jersey", 8882190],
    ["Virginia", 8535519],
    ["Washington", 7614893],
    ["Arizona", 7278717],
    ["Massachusetts", 6949503],
    ["Tennessee", 6833174],
    ["Indiana", 6732219],
    ["Missouri", 6137428],
    ["Maryland", 6045680],
    ["Wisconsin", 5822434],
    ["Colorado", 5758736],
    ["Minnesota", 5639632],
    ["South Carolina", 5148714],
    ["Alabama", 4903185],
    ["Louisiana", 4648794],
    ["Kentucky", 4467673],
    ["Oregon", 4217737],
    ["Oklahoma", 3956971],
    ["Connecticut", 3565287],
    ["Utah", 3205958],
    ["Puerto Rico", 3193694],
    ["Iowa", 3155070],
    ["Nevada", 3080156],
    ["Arkansas", 3017825],
    ["Mississippi", 2976149],
    ["Kansas", 2913314],
    ["New Mexico", 2096829],
    ["Nebraska", 1934408],
    ["West Virginia", 1792147],
    ["Idaho", 1787065],
    ["Hawaii", 1415872],
    ["New Hampshire", 1359711],
    ["Maine", 1344212],
    ["Montana", 1068778],
    ["Rhode Island", 1059361],
    ["Delaware", 973764],
    ["South Dakota", 884659],
    ["North Dakota", 762062],
    ["Alaska", 731545],
    ["District of Columbia", 705749],
    ["Vermont", 623989],
    ["Wyoming", 578759],
    ["Guam", 165718],
    ["Virgin Islands", 104914],
    ["American Samoa", 55641],
    ["Northern Mariana Islands", 55194]
] as [string,number][]).sort((a,b) => a[0].localeCompare(b[0]));

export const Regions = new Map<string,number>(regionList);